import { Link } from 'react-router-dom';

const stats = [
  { value: '3', label: '内容频道' },
  { value: '24h', label: '持续更新' },
  { value: '100+', label: '每日资讯' },
  { value: '全平台', label: '多端适配' },
];

export default function SiteIntro() {
  return (
    <section className="relative rounded-lg overflow-hidden bg-primary-800">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20background%20with%20flowing%20lines%20and%20dots%20in%20deep%20navy%20blue%20and%20soft%20orange%20highlights%2C%20modern%20minimal%20tech%20texture%2C%20clean%20elegant%20composition%2C%20no%20text&width=1600&height=600&seq=intro-bg-91niu&orientation=landscape"
          alt="9·1牛网品牌背景图"
          title="9·1牛网 - 全方位资讯与内容服务平台"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 p-6 md:p-12">
        <h2 className="font-heading font-black text-2xl md:text-4xl text-background-50 leading-snug">
          全方位资讯与内容服务平台
        </h2>
        <p className="mt-4 max-w-2xl text-sm md:text-base text-primary-100/90 leading-relaxed">
          9·1牛网提供丰富多样的资讯内容，涵盖新闻、娱乐、生活等多个领域，满足用户多样化的信息需求。用户可在这里获取最新资讯和实用内容。
        </p>
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((s) => (
            <div key={s.label} className="border-l-2 border-accent-500 pl-4">
              <p className="font-heading font-black text-2xl md:text-3xl text-background-50">{s.value}</p>
              <p className="text-xs md:text-sm text-primary-100/80 mt-1">{s.label}</p>
            </div>
          ))}
        </div>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <Link
            to="/about"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解我们的故事
            <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md border border-primary-100/40 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}